import API from "../Common/Endpoint/serviceConstrants";
import axiosInstance from '../Common/Axios/axiosInstance';
export const callGetThemeApi = async (payload) => {
  const { data = {} } = await axiosInstance.get(API.themeManagement,{
    params:{
      id:payload?.id
    }
  });
  return data;
};
